@if ($model() != null) {
    <div class="card shadow" [class.pinned]="$model().isPinned" [class.in-context]="$isInContext()" [class.removing]="$isRemovingFromDirectory()">
        @if ($isContextMode()) {
            <!-- Layer de edição de agrupamento por contexto -->
            <div class="context-mode" [class.selected]="$model().id == $contextModeDispatcherId()" #contextModeRef>
                @if ($shouldShowMoveUpButton()) {
                    @let mt1 = $hasFilteredFlowItemInContext()
                        ? 'Não é possível reordenar o Agrupamento pois há um ou mais de seus Fluxos filtrados no momento'
                        : 'Subir este Fluxo na ordenação do Agrupamento';
                    <i class="fas fa-arrow-circle-up move"
                       [matTooltip]="mt1"
                       [class.disabled]="$hasFilteredFlowItemInContext()"
                       (click)="executeAction(FlowDefinitionItemActionType.MoveUpInContext)"
                       (keyDown)="executeAction(FlowDefinitionItemActionType.MoveUpInContext)"
                    ></i>
                }

                @if ($shouldShowMoveDownButton()) {
                    @let mt2 = $hasFilteredFlowItemInContext()
                        ? 'Não é possível reordenar o Agrupamento pois há um ou mais de seus Fluxos filtrados no momento'
                        : 'Descer este Fluxo na ordenação do Agrupamento';
                    <i class="fas fa-arrow-circle-down move" featureHint="flowDefinitionContext|Move"
                       [matTooltip]="mt2"
                       [class.disabled]="$hasFilteredFlowItemInContext()"
                       (click)="executeAction(FlowDefinitionItemActionType.MoveDownInContext)"
                       (keyDown)="executeAction(FlowDefinitionItemActionType.MoveDownInContext)"
                    ></i>
                }

                @if ($shouldShowAddButton()) {
                    @if ($isDispatcherDiretory()) {
                        <i class="fas fa-plus-circle add" featureHint="flowDefinitionInboxDirectory|Add" featureHintExclusiveGroup
                           matTooltip="Adicionar este Fluxo à pasta previamente selecionada"
                           (click)="executeAction(FlowDefinitionItemActionType.AddItemToDirectory)"
                           (keyDown)="executeAction(FlowDefinitionItemActionType.AddItemToDirectory)"
                        ></i>
                    } @else {
                        @let mt3 = $hasReachedMaxLimit()
                            ? 'Não é possível adicionar ao Agrupamento em questão pois o mesmo atingiu o limite máximo de Fluxos'
                            : 'Adicionar este Fluxo a um Agrupamento com o Fluxo previamente selecionado';
                        <i class="fas fa-plus-circle add" featureHint="flowDefinitionContext|Add" featureHintExclusiveGroup
                           [matTooltip]="mt3"
                           [class.disabled]="$hasReachedMaxLimit()"
                           (click)="executeAction(FlowDefinitionItemActionType.AddItemToContext)"
                           (keyDown)="executeAction(FlowDefinitionItemActionType.AddItemToContext)"
                        ></i>
                    }
                }

                @if ($shouldShowRemoveButton()) {
                    <i class="fas fa-minus-circle remove" featureHint="flowDefinitionContext|Remove"
                       matTooltip="Remover este Fluxo do Agrupamento atual"
                       (click)="executeAction(FlowDefinitionItemActionType.RemoveItemFromContext)"
                       (keyDown)="executeAction(FlowDefinitionItemActionType.RemoveItemFromContext)"
                    ></i>
                }
            </div>
        }

        <div class="card-body">
            <h6 class="title m-0" (click)="executeAction(FlowDefinitionItemActionType.Open)" (keyDown)="executeAction(FlowDefinitionItemActionType.Open)">
                {{$model().name}}
            </h6>

            <hr class="header-divider">

            <div class="body">
                <!-- Tags -->
                <div class="tags" featureHint="flowDefinitionItemTags" featureHintShowOn="right">
                    <!-- Pin -->
                    <span class="fas fa-thumbtack tag pin"
                          matTooltip="{{$model().isPinned ? 'Desafixar' : 'Fixar'}} Fluxo no topo"
                          [class.on]="$model().isPinned"
                          (click)="executeAction($model().isPinned ? FlowDefinitionItemActionType.Unpin : FlowDefinitionItemActionType.Pin)"
                          (keyDown)="executeAction($model().isPinned ? FlowDefinitionItemActionType.Unpin : FlowDefinitionItemActionType.Pin)"
                    ></span>

                    <!-- Versão -->
                    <span class="fa-stack tag version" matTooltip="Versão atual">
                        <i class="far fa-circle fa-stack-2x background"></i>
                        <span class="fa-stack-1x text">{{$model().version}}</span>
                    </span>

                    <!-- Ativação -->
                    <span class="fas fa-check-circle tag active"
                          matTooltip="Fluxo {{$model().isActive ? 'ativo' : 'inativo'}}"
                          [class.on]="$model().isActive"
                    ></span>

                    <!-- Publicação -->
                    <span class="fas fa-cloud tag published"
                          matTooltip="Última versão do Fluxo {{$model().isPublished ? '' : 'não '}}publicada"
                          [class.on]="$model().isPublished"
                    ></span>

                    <!-- Configurações Imediatas Temporais -->
                    <span class="fas fa-history tag hot-configs"
                          matTooltip="Fluxo {{$hasTemporalHotConfigs() ? '' : 'não '}}contém Configurações Imediatas Temporais ativadas"
                          [class.on]="$hasTemporalHotConfigs()"
                    ></span>

                    <!-- Modo Não Listado -->
                    <span class="fas fa-eye-slash tag hot-configs"
                          matTooltip="Fluxo {{$model().isUnlistedModeActive ? '' : 'não '}}está com Modo Não Listado ativado"
                          [class.on]="$model().isUnlistedModeActive"
                    ></span>
                </div>

                @if (!$isRemovingFromDirectory()) {
                    <!-- Ações -->
                    <div class="actions" featureHint="flowDefinitionItemActions" featureHintShowOn="right">
                        <!-- Acessar/Editar -->
                        <a class="card-link"
                            matTooltip="{{$model().isActive == false ? 'Acessar' : ($model().isPublished ? 'Acessar' : 'Editar')}}"
                            (click)="executeAction(FlowDefinitionItemActionType.Open)"
                            (keyDown)="executeAction(FlowDefinitionItemActionType.Open)"
                        >
                            <i class="fas" [ngClass]="$model().isActive == false ? 'fa-right-to-bracket' : ($model().isPublished ? 'fa-right-to-bracket' : 'fa-pen')"></i>
                        </a>

                        @if ($model().isActive) {
                            <!-- Instanciar última versão -->
                            @if ($model().isPublished || $model().version > 1) {
                                <a class="card-link"
                                   matTooltip="Instanciar a última versão publicada"
                                   (click)="executeAction(FlowDefinitionItemActionType.Instantiate)"
                                   (keyDown)="executeAction(FlowDefinitionItemActionType.Instantiate)"
                                >
                                    <i class="fas fa-external-link-alt"></i>
                                </a>
                            }

                            <!-- Versionar -->
                            @if ($model().isPublished) {
                                <a class="card-link"
                                   matTooltip="Versionar"
                                   (click)="executeAction(FlowDefinitionItemActionType.NewVersion)"
                                   (keyDown)="executeAction(FlowDefinitionItemActionType.NewVersion)"
                                >
                                    <i class="fas fa-code-fork"></i>
                                </a>
                            }

                            <!-- Clonar -->
                            <a class="card-link"
                               matTooltip="Clonar"
                               (click)="executeAction(FlowDefinitionItemActionType.Clone)"
                               (keyDown)="executeAction(FlowDefinitionItemActionType.Clone)"
                            >
                                <i class="fas fa-clone"></i>
                            </a>

                            <!-- Publicar -->
                            @if (!$model().isPublished) {
                                <a class="card-link"
                                   matTooltip="Publicar"
                                   (click)="executeAction(FlowDefinitionItemActionType.Publish)"
                                   (keyDown)="executeAction(FlowDefinitionItemActionType.Publish)"
                                >
                                    <i class="fas fa-cloud-upload-alt"></i>
                                </a>
                            }

                            <!-- Agrupar Fluxos -->
                            @if ($model().isActive) {
                                <a class="card-link"
                                   matTooltip="Agrupar Fluxos"
                                   (click)="executeAction(FlowDefinitionItemActionType.GroupByContext)"
                                   (keyDown)="executeAction(FlowDefinitionItemActionType.GroupByContext)"
                                >
                                    <i class="fas fa-layer-group"></i>
                                </a>
                            }

                            <!-- Desativar -->
                            @if ($model().isActive && ($model().isPublished || $model().version > 1)) {
                                <a class="card-link"
                                   matTooltip="Desativar"
                                   (click)="executeAction(FlowDefinitionItemActionType.Deactivate)"
                                   (keyDown)="executeAction(FlowDefinitionItemActionType.Deactivate)"
                                >
                                    <i class="fas fa-times-circle"></i>
                                </a>
                            }

                            <!-- Remover -->
                            @if (!$model().isPublished && $model().version == 1) {
                                <a class="card-link"
                                   matTooltip="Remover"
                                   (click)="executeAction(FlowDefinitionItemActionType.Delete)"
                                   (keyDown)="executeAction(FlowDefinitionItemActionType.Delete)"
                                >
                                    <i class="fas fa-trash"></i>
                                </a>
                            }
                        }

                        <!-- Ativar -->
                        @if (!$model().isActive) {
                            <a class="card-link"
                               matTooltip="Ativar"
                               (click)="executeAction(FlowDefinitionItemActionType.Activate)"
                               (keyDown)="executeAction(FlowDefinitionItemActionType.Activate)"
                            >
                                <i class="fas fa-check-circle"></i>
                            </a>
                        }

                        <!-- Mover para pasta -->
                        <span class="fas fa-up-down-left-right move" matTooltip="Clique e arraste para mover o {{Utils.isNotNullOrEmpty($model().contextId) ? 'Agrupamento' : 'Fluxo'}} para uma pasta"></span>
                    </div>
                }
            </div>
        </div>
    </div>
}
